import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/Badge'
import { examStatusLabel, examStatusTone } from '../status'
import type { ExamStatus } from '../types'

export function ExamStatusBadge({ status, size }: { status: ExamStatus; size?: 'sm' | 'md' }) {
  const { t } = useTranslation('exams')
  return (
    <Badge tone={examStatusTone[status]} size={size} dot>
      {t(examStatusLabel[status])}
    </Badge>
  )
}

interface GradeBadgeProps {
  grade: string | null
  isPass: boolean
  isAbsent?: boolean
  isMissing?: boolean
  size?: 'sm' | 'md'
}

/** Grade chip: green when passed, red when failed; absent / not entered are spelled out. */
export function GradeBadge({ grade, isPass, isAbsent, isMissing, size = 'sm' }: GradeBadgeProps) {
  const { t } = useTranslation('exams')
  if (isAbsent)
    return (
      <Badge tone="danger" size={size}>
        {t('Absent')}
      </Badge>
    )
  if (isMissing)
    return (
      <Badge tone="neutral" size={size}>
        {t('Not entered')}
      </Badge>
    )
  if (!grade)
    return (
      <Badge tone={isPass ? 'success' : 'danger'} size={size}>
        {isPass ? t('Pass') : t('Fail')}
      </Badge>
    )
  return (
    <Badge
      tone={isPass ? 'success' : 'danger'}
      size={size}
      aria-label={isPass ? t('Grade {{grade}}, passed', { grade }) : t('Grade {{grade}}, failed', { grade })}
    >
      {grade}
    </Badge>
  )
}
